<template>
    <app-layout>
        <template v-slot:header>
            <Header :title="$t('my_requests')"
                    :isFilter="false">
            </Header>
        </template>
        <template v-slot:header-mobile>
            <HeaderMobile :title="$t('my_requests')"
                          :isFilter="false">
            </HeaderMobile>
        </template>
        <b-tabs content-class="py-5 position-relative" v-model="tabIndex">
            <div class="tabs-bottom-line"></div>

            <!-- Purchase Order Form Tab -->
            <b-tab v-if="checkPermission('purchaseorderform_index') && isLeadershipTeam">
                <template #title>
                    <span class="d-flex align-items-center">{{ $t('purchase_orders') }}</span>
                </template>
                <div class="d-flex justify-content-end mb-2">
                    <b-button
                        v-if="checkPermission('purchaseorderform_store')"
                        variant="primary"
                        class="mr-2"
                        @click="$router.push('/purchase-order/request-form')"
                    >
                        {{ $t('new_request') }}
                    </b-button>
                </div>
                <PurchaseOrderForm
                    v-if="tabIndex === indexes.purchaseOrderForm"
                    :filter="filter"
                />
            </b-tab>

        </b-tabs>
    </app-layout>
</template>

<script>
import AppLayout from "@/layouts/AppLayout.vue";
import Header from "@/layouts/AppLayout/Header.vue"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue"
import PurchaseOrderForm from "@/modules/staff/pages/components/PurchaseOrderForm.vue";

export default {
    components: {
        PurchaseOrderForm,
        AppLayout,
        Header,
        HeaderMobile,
    },
    data() {
        return {
            tabIndex: 0,
            filter: {},
            stateData: {},
            indexes: {
                purchaseOrderForm: 1,
            }
        }
    },
    metaInfo() {
        return {
            title: this.$t("my_requests")
        }
    },
    computed: {
        isLeadershipTeam() {
            return !!(this.stateData && this.stateData.staff && this.stateData.staff.is_leadership_team);
        }
    },
    methods: {
        loadData() {
            if (!this.stateData) return;
            this.filter = {
                params: {
                    user_id: this.stateData.id,
                }
            }
        },
    },
    created() {
        this.$store.dispatch("auth/initUser");
        this.stateData = { ...this.$store.getters['auth/getUser'] }

        let currentIndex = 0;

        if (this.checkPermission('purchaseorderform_index') && this.isLeadershipTeam) {
            this.indexes.purchaseOrderForm = currentIndex++;
        } else {
            this.indexes.purchaseOrderForm = -1;
        }

        if (this.$route.params.tab) {
            this.tabIndex = parseInt(this.$route.params.tab)
        }

        this.loadData();
    },
}
</script>

<style lang="scss">
.document_request_dropdown {
    tr {
        td:first-child {
            padding-right: 0px !important;
        }
    }
}
</style>
